import React from 'react';
import { SpeakerProfile } from '../../../lib/api';
import { formatSpeakerNames } from './speakerDisplayUtils';
import './BookMeetingModal.scss';

interface MeetingDetailsSectionProps {
  speakers: SpeakerProfile[];
  date: string;
  startTimeEvent: string;
  endTimeEvent: string;
  transformedTimeZone: string;
  showLocalTime: boolean;
  startTimeLocal: string;
  endTimeLocal: string;
  isLoading: boolean;
  loadingMessage?: string;
}

const MeetingDetailsSection: React.FC<MeetingDetailsSectionProps> = ({
  speakers,
  date,
  startTimeEvent,
  endTimeEvent,
  transformedTimeZone,
  showLocalTime,
  startTimeLocal,
  endTimeLocal,
  isLoading,
  loadingMessage
}) => {
  const hasMultipleSpeakers = speakers.length > 1;
  const primarySpeaker = speakers.length > 0 ? speakers[0] : null;
  const formattedSpeakerNames = formatSpeakerNames(speakers);

  return (
    <div className="speaker-section">
      <div className="speaker-photo-list">
        {speakers.map((sp) => {
          if (!sp.profileImageUrl) {
            return null;
          }

          return (
            <div key={sp.id} className="speaker-photo-container">
              <img
                src={sp.profileImageUrl}
                alt=""
                className="speaker-photo"
              />
            </div>
          );
        })}
      </div>
      <div className="speaker-info-and-details">
        <div className="speaker-info">
          {hasMultipleSpeakers && (
            <>
              {formattedSpeakerNames.map((displayName, index) => {
                const sp = speakers[index];
                return (
                  <h4 key={sp?.id ?? `${displayName}-${index}`} className="speaker-name">
                    {displayName}
                  </h4>
                );
              })}
            </>
          )}
          {!hasMultipleSpeakers && primarySpeaker && (
            <>
              {primarySpeaker.name && (
                <h4 className="speaker-name">{primarySpeaker.name}</h4>
              )}
              {primarySpeaker.title && (
                <p className="speaker-title">{primarySpeaker.title}</p>
              )}
            </>
          )}
        </div>
        <div className="meeting-details">
          <div className="meeting-date">{date}</div>
          <div className="meeting-time">
            {startTimeEvent} - {endTimeEvent}
            <span className="normal-case word-break"> {transformedTimeZone}</span>
          </div>
          {showLocalTime && startTimeLocal && endTimeLocal && (
            <div className="meeting-time-local">Your local time: {startTimeLocal} - {endTimeLocal}</div>
          )}
        </div>
        {isLoading && loadingMessage && (
          <div className="booking-status-message">
            {loadingMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default MeetingDetailsSection;

